import React from 'react';
import { cn } from '../../utils/cn';

export type BadgeTone = 'neutral' | 'brand' | 'signal' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  className?: string;
}

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-sunken text-ink',
  brand: 'bg-brand-soft text-on-brand-soft',
  signal: 'bg-signal text-on-signal',
  success: 'bg-success-surface text-success-text',
  warning: 'bg-warning-surface text-warning-text',
  danger: 'bg-danger-surface text-danger-text',
};

export const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', children, className }) => (
  <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold', toneClasses[tone], className)}>
    {children}
  </span>
);
